import { createAction } from 'redux-actions'

export const SET_WORKSPACE_SETTINGS_SETTINGS = 'SET_WORKSPACE_SETTINGS_SETTINGS'
export const setWorkspaceSettingsSettings = createAction(
  SET_WORKSPACE_SETTINGS_SETTINGS
)
